import type { RedemptionStatus } from '@/api/gen'
import {
  getAccountRedemptionStatusRetrieveQueryKey,
  useAccountRedemptionStatusRetrieve,
} from '@/api/gen'
import { queryClient } from '@/query-client'
import { safeNumber } from '@/utils/helpers'

import { useAuth } from './use-auth'

export const useEdgeBalance = () => {
  const { isAuthorized } = useAuth()
  const { data, isFetching } = useAccountRedemptionStatusRetrieve({
    query: {
      refetchOnMount: false,
      refetchOnWindowFocus: true,
      enabled: isAuthorized,
    },
  })

  const reduceBalance = (amount: number) => {
    queryClient.setQueryData(
      getAccountRedemptionStatusRetrieveQueryKey(),
      (oldData: RedemptionStatus) => ({
        ...oldData,
        edge_balance: oldData.edge_balance - amount,
      }),
    )
  }

  const applyDiscount = () => {
    queryClient.setQueryData(
      getAccountRedemptionStatusRetrieveQueryKey(),
      (oldData: RedemptionStatus) => ({
        ...oldData,
        first_subscription_discount_available: false,
      }),
    )
  }

  return {
    balance: data?.edge_balance ?? 0,
    isDiscounted: data?.first_subscription_discount_available ?? false,
    isRedemptionUnlocked: data?.is_redemption_unlocked ?? false,
    edgeToUnlock: data?.edge_required_for_unlock ?? 0,
    edgeEarned: safeNumber(data?.lifetime_edge_earned),
    loading: isFetching,
    reduceBalance,
    applyDiscount,
  }
}
